/* =============================================
   Related Products Custom Section - JavaScript v8
   Simplified - no hover overlay
   ============================================= */

(function() {
  'use strict';
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRelatedProductsCustom);
  } else {
    initRelatedProductsCustom();
  }
  
  function initRelatedProductsCustom() {
    initSwatches();
  }
  
  /**
   * Initialize color swatch functionality
   */
  function initSwatches() {
    var swatches = document.querySelectorAll('.rpc-swatch');
    
    swatches.forEach(function(swatch) {
      swatch.addEventListener('click', handleSwatchClick);
    });
  }
  
  /**
   * Handle swatch click event
   */
  function handleSwatchClick(e) {
    e.preventDefault();
    e.stopPropagation();
    
    var swatch = this;
    var card = swatch.closest('.rpc-card');
    var container = swatch.closest('.rpc-swatches');
    
    if (!card || !container) return;
    
    // Update active state
    container.querySelectorAll('.rpc-swatch').forEach(function(s) {
      s.classList.remove('active');
    });
    swatch.classList.add('active');
    
    // Update main product image
    var newImage = swatch.dataset.variantImage;
    if (newImage && newImage.trim() !== '') {
      var mainImg = card.querySelector('.rpc-image');
      if (mainImg) {
        mainImg.src = newImage;
      }
    }
    
    // Update price display
    updatePrice(card, swatch);
    
    return false;
  }
  
  /**
   * Update price display based on selected variant
   */
  function updatePrice(card, swatch) {
    var price = swatch.dataset.variantPrice;
    var comparePrice = swatch.dataset.variantComparePrice;
    var priceEl = card.querySelector('[data-current-price]');
    var compareEl = card.querySelector('[data-compare-price]');
    
    if (priceEl && price) {
      priceEl.textContent = formatMoney(price);
    }
    
    if (compareEl) {
      if (comparePrice && comparePrice.trim() !== '' && parseInt(comparePrice) > parseInt(price)) {
        compareEl.textContent = formatMoney(comparePrice);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
  }
  
  /**
   * Format price in Euro format
   */
  function formatMoney(cents) {
    if (!cents) return '';
    cents = parseInt(cents);
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  
  // Expose init function for dynamic loading
  window.initRelatedProductsCustom = initRelatedProductsCustom;
  
})();